import { IState } from 'shared/store';

export function selectRosReestrSelector(state: IState): boolean {
  return state.offerData.rosreestrInfoV2?.showCheckedLabel || false;
}
